/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(organizationId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetSCCorrespondencesByOrganizationId: {
        $xmlns: 'http://dobs.pa.gov/sc/correspondence/bpm/1.0',
        OrganizationId: organizationId
      }
    },
    blueprintArrays: ['GetSCCorrespondencesByOrganizationIdResponse.SC_Correspondence'],
    blueprint: {
      correspondences: [
        '$..SC_Correspondence',
        {
          id: '$.ID',
          type: '$.Type',
          requestedBy: '$.RequestedBy',
          requestedOn: '$.RequestedOn',
          repliedBy: '$.RepliedBy',
          repliedOn: '$.RepliedOn',
          isInternal: '$.IsInternal'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      _.each(response.correspondences, function(correspondence) {
        correspondence.source = correspondence.isInternal === '0' ? 'External' : 'Internal';
      });

      defer.resolve(response.correspondences);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
